import { SanityColumnsSection } from 'graphql-types';
import React, { useState } from 'react';
import { findTranslation } from '../../utils/findTranslation';
import { usePageContext } from '../context/pageContext';
import { CTA } from '../html-tag/Cta';
import { Blocks } from '../ui/blocks/Blocks';
import * as styles from './ColumnsSection.module.scss';

interface Props {
  section: SanityColumnsSection;
}
//TODO

export const ColumnsSection: React.FC<Props> = ({ section }) => {
  if (!section) return null;
  const { lang, defaultLang } = usePageContext();
  return (
    <div className={styles.wrapper}>
      <h2>{findTranslation(section?._rawTitleSection, lang, defaultLang)}</h2>
      <div className={section?._rawColumnsList?.length !== 0 ? styles.row : styles.column}>
        {section?._rawColumnsList?.map((blocks, index) => {
          return (
            <div
              className={styles.content}
              key={`block-${index}`}
            >
              <Blocks blocks={findTranslation(blocks, lang, defaultLang)} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
